module.exports = __webpack_public_path__ + "img/3.5ad5c2ab.png";